import { authFetch } from "../helpers/FetchHelpers";

const { default: DataService } = require("./DataService");

const mapSession = (session) => session ? {
    Id: session.id,
    WarehouseId: session.warehouse_id,
    Status: session.status,
    OpenedBy: session.opened_by,
    OpenAt: session.open_at,
    ClosedBy: session.closed_by,
    CloseAt: session.close_at,
    TotalSales: session.total_sales,
    TotalCash: session.total_cash,
    TotalCashbon: session.total_cashbon,
    TotalProfit: session.total_profit,
} : undefined;

class CashierDataService extends DataService {
    constructor() {
        super("cashier")
    }

    getStatus() {
        return authFetch(process.env.REACT_APP_API_URL + '/cashier/status', 'GET', null)
            .then((data) => {
                return {
                    isOpen: data.data?.is_open === true,
                    isSessionOwner: data.data?.is_session_owner === true,
                    session: mapSession(data.data?.session),
                    errorMessage: data.data?.errorMessage || data.header?.error_message,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }

    setStatus(status) {
        return authFetch(process.env.REACT_APP_API_URL + '/cashier/status', 'POST', JSON.stringify({ status }))
            .then((data) => {
                return {
                    session: mapSession(data.data),
                    message: data.header?.message,
                    errorMessage: data.data?.errorMessage || data.header?.error_message,
                    needRelogin: data.data?.needRelogin,
                }
            })
    }
}

export default CashierDataService;
